import { render, staticRenderFns } from "./TempData.vue?vue&type=template&id=1f658a95&scoped=true&"
import script from "./TempData.vue?vue&type=script&lang=js&"
export * from "./TempData.vue?vue&type=script&lang=js&"
import style0 from "./TempData.vue?vue&type=style&index=0&id=1f658a95&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f658a95",
  null
  
)

export default component.exports